export default __webpack_public_path__ + "static/media/excelentealumno.c4ec3f5d.jpg";